import React from 'react';
import { Section } from './ui/Section';
import { ArrowDown } from 'lucide-react';
export function MechanismSection() {
  return <Section className="bg-primary text-center" data-id="element-117">
      <div className="max-w-3xl mx-auto" data-id="element-118">
        <h2 className="text-3xl md:text-5xl font-bold text-white mb-8" data-id="element-119">
          El mecanismo: <br data-id="element-120" />
          <span className="text-accent-blue" data-id="element-121">1 Página + 3 Mensajes</span>
        </h2>

        <div className="space-y-6 text-lg text-text-secondary mb-12" data-id="element-122">
          <p data-id="element-123">¿Por qué esto funciona cuando lo demás falla?</p>
          <p data-id="element-124">Porque un principiante no pierde por falta de talento.</p>
          <p className="text-xl text-white font-medium" data-id="element-125">
            Pierde por fuga de energía: demasiadas decisiones.
          </p>
          <p data-id="element-126">
            Este mecanismo elimina decisiones y te deja con lo único que
            importa:
          </p>
        </div>

        <div className="flex flex-col md:flex-row justify-center items-center gap-6" data-id="element-127">
          <div className="bg-section px-8 py-6 rounded-xl border border-accent-blue/30 w-full md:w-auto" data-id="element-128">
            <span className="block text-2xl font-bold text-white" data-id="element-129">
              Oferta Clara
            </span>
          </div>
          <ArrowDown className="md:-rotate-90 text-text-muted w-6 h-6" data-id="element-130" />
          <div className="bg-section px-8 py-6 rounded-xl border border-accent-blue/30 w-full md:w-auto" data-id="element-131">
            <span className="block text-2xl font-bold text-white" data-id="element-132">
              Página Clara
            </span>
          </div>
          <ArrowDown className="md:-rotate-90 text-text-muted w-6 h-6" data-id="element-133" />
          <div className="bg-section px-8 py-6 rounded-xl border border-accent-blue/30 w-full md:w-auto" data-id="element-134">
            <span className="block text-2xl font-bold text-white" data-id="element-135">
              Seguimiento
            </span>
          </div>
        </div>
      </div>
    </Section>;
}